import {
    isNil,
} from 'lodash';
import {
    CardBrand,
    PaymentMethodType,
} from '../models';
import {
    HEALTHY_CHURCH_HOST_URL,
} from './constants';
import amex from '../assets/amex.svg';
import bankAccount from '../assets/bank_account.svg';
import card from '../assets/credit_card@2x.svg';
import diners from '../assets/diners_club.svg';
import discover from '../assets/discover.svg';
import jcb from '../assets/jcb.svg';
import mastercard from '../assets/mastercard.svg';
import unionpay from '../assets/union_pay.svg';
import visa from '../assets/visa.svg';

export function getImageUrl(imageAsset) {
    if (!isNil(HEALTHY_CHURCH_HOST_URL)) {
        return `${HEALTHY_CHURCH_HOST_URL}/${imageAsset}`;
    }

    return imageAsset;
}

export function getPaymentMethodTypeImage(
    paymentMethodType: PaymentMethodType,
    cardBrand?: CardBrand,
): any {
    switch (paymentMethodType) {
        case PaymentMethodType.BankAccount:
            return getImageUrl(bankAccount);

        case PaymentMethodType.Card: {
            if (isNil(cardBrand)) {
                console.error('For payment method type of \'Card\', the \'cardBrand\' parameter is also required');
                return null;
            }

            switch (cardBrand) {
                case CardBrand.AmEx:
                    return getImageUrl(amex);
                case CardBrand.DinersClub:
                    return getImageUrl(diners);
                case CardBrand.Discover:
                    return getImageUrl(discover);
                case CardBrand.JCB:
                    return getImageUrl(jcb);
                case CardBrand.Mastercard:
                    return getImageUrl(mastercard);
                case CardBrand.UnionPay:
                    return getImageUrl(unionpay);
                case CardBrand.Visa:
                    return getImageUrl(visa);

                default: {
                    console.warn('Unexpected \'cardbrand\' value:', cardBrand);
                    return getImageUrl(card);
                }
            }
        }

        default:
            console.error('Unexpected value for \'paymentMethodType\':', paymentMethodType);
            return null;
    }
}
